import { Injectable, inject } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Observable, BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { MediaModel, MediaService } from "libs/media/src/lib";
import { ClientName } from "libs/config/client.names";

@Injectable({
	providedIn: "root"
})
export class FileListDashboardEntriesDatasource extends DataSource<Partial<MediaModel>> {
	private mediaService = inject(MediaService);
	private designatedClient: ClientName;

	private _sort: MatSort;
	private _paginator: MatPaginator;
	private _filter = "";
	private _customerIdFilter = "";

	get sort(): MatSort {
		return this._sort;
	}

	set sort(sort: MatSort) {
		this._sort = sort;
	}

	get filter(): string {
		return this.textFilterSubject.value;
	}

	get customerIdFilter(): string {
		return this.customerIdFilterSubject.value;
	}

	set filter(filter: string) {
		//remove backslashes since they break the serverside regex
		this._filter = filter.trim().toLowerCase().replace(/\\/g, "");
		this.textFilterSubject.next(this._filter);
	}

	set customerIdFilter(customerId: string) {
		this._customerIdFilter = customerId.trim().toLowerCase();
		this.customerIdFilterSubject.next(this._customerIdFilter);
	}

	set paginator(paginator: MatPaginator) {
		this._paginator = paginator;
	}

	get paginator() {
		return this._paginator;
	}

	setDesignatedClient(clientName: ClientName) {
		this.designatedClient = clientName;
	}

	mediaSubject = new BehaviorSubject<Partial<MediaModel>[]>([]);
	textFilterSubject = new BehaviorSubject<string>("");
	customerIdFilterSubject = new BehaviorSubject<string>("");

	override connect(): Observable<Partial<MediaModel>[]> {
		return this.mediaSubject.asObservable();
	}

	loadMedia() {
		let skip = 0;
		let limit = 6;
		if (this._paginator) {
			skip = this._paginator.pageIndex * this._paginator.pageSize;
			limit = this._paginator.pageSize;
		}

		if (this.designatedClient === ClientName.TM) {
			this.loadMediaForTM(skip, limit);
		} else if (this.designatedClient === ClientName.TM_ADMIN) {
			this.loadMediaForTMAdmin(skip, limit);
		}
	}

	private loadMediaForTM(skip: number, limit: number) {
		this.mediaService
			.getMediaFilesCustomerPaginated(
				skip,
				limit,
				this._filter,
				this._sort.active,
				this._sort.direction
			)
			.pipe(
				map((response: { media: Partial<MediaModel>[]; count: number }) => {
					this._paginator.length = response.count;
					return response.media;
				})
			)
			.subscribe((media: Partial<MediaModel>[]) => this.mediaSubject.next(media));
	}

	private loadMediaForTMAdmin(skip: number, limit: number) {
		if (this._customerIdFilter === "" && this._filter.length < 8) {
			return;
		}
		this.mediaService
			.getMediaFilesAdminPaginated(
				skip,
				limit,
				this._filter,
				this._sort.active,
				this._sort.direction,
				this._customerIdFilter
			)
			.pipe(
				map((response: { media: Partial<MediaModel>[]; count: number }) => {
					this._paginator.length = response.count;
					return response.media;
				})
			)
			.subscribe((media: Partial<MediaModel>[]) => this.mediaSubject.next(media));
	}

	override disconnect() {
		this.mediaSubject.complete();
	}
}
